import React, { forwardRef } from "react";
import { Autocomplete, TextField } from "@mui/material";
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Popper from '@mui/material/Popper';

const MuiAutocomplete = forwardRef(({
  disabled,
  value,
  id,
  options,
  className,
  getOptionLabel,
  autoCompleteStyle = {},
  textFieldStyle = {},
  InputLabelProps = {},
  renderOption,
  filterOptions,
  onChange,
  label,
  displayEmpty,
  required,
  isSubmitted=false,
  validationErrMsg="",
  multiline = false,
  maxRows = 3,
  onInputChange,
  open,
  onKeyUp,
  onKeyDown,
  usePopper=false,
  popperStyle={},
  // multiple = false,
  // limitTags = 2
}, ref) => {
//   console.log("valur given-------",value)
//  console.log("optionsCHanging------------", options)
const defaultStyles = {
    backgroundColor: "#FFF",
    fontSize: "14px",
    color: "#101010",
    fontWeight: "400",
    "& .MuiInputBase-input": {
      color: "#000",
      padding: '0px !important',
    },
    "& .MuiInputBase-input.Mui-disabled": {
      WebkitTextFillColor: "black", // For WebKit browsers
    },
    "& .MuiInputBase-root.Mui-disabled": {
      backgroundColor: "#d3d3d3",
    },
    ...textFieldStyle,
    };

  return (
<FormControl fullWidth>
<Autocomplete
      // multiple={multiple}
      // limitTags={limitTags}
      ref={ref}
      disablePortal
      id={id}
      disabled={disabled}
      value={value}
      onChange={onChange}
      options={options}
      required={required}
      className={className}
      displayEmpty={displayEmpty}
      getOptionLabel={getOptionLabel}
      filterOptions={filterOptions}
      onInputChange={onInputChange}
      open={open}
      sx={{ ...autoCompleteStyle }}
      renderOption={renderOption}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          sx={defaultStyles}
          InputLabelProps={InputLabelProps}
          multiline = {multiline}
          maxRows={maxRows}
          inputProps={{
            ...params.inputProps
          }}
          onKeyUp={onKeyUp}
          onKeyDown={onKeyDown}
        />
      )}
      PopperComponent={usePopper ? (props) => (
        <Popper {...props} style={popperStyle} />
      ) : null}
      />
    {isSubmitted && validationErrMsg && <FormHelperText
    style={{ minHeight: '1em', fontFamily: "inter",fontSize: "16px",fontStyle: "normal",fontWeight: "400",lineHeight: "24px", }} // Ensure consistent height
    error={isSubmitted && validationErrMsg}
     >
    {validationErrMsg}
    </FormHelperText>}
    </FormControl>
  );
})

export default MuiAutocomplete;

